/**
 * QR для реферальных ссылок (§7 «реферальные ссылки/QR», Phase 15 E1).
 *
 * Обёртка над вендоренным qrlib.ts (MIT, Kazuhiko Arase): строит SVG-строку
 * из модулей QR без внешних зависимостей и DOM. Данные в QR — только
 * серверная ссылка (I-7: URL t.me клиент не генерит).
 */

import qrcode from "./qrlib";

interface QrLib {
  addData(data: string): void;
  make(): void;
  getModuleCount(): number;
  isDark(row: number, col: number): boolean;
}

/** SVG-разметка QR для `text` (typeNumber 0 = авто-версия, EC level M). */
export function qrSvg(text: string, cellSize = 4, margin = 2): string {
  const qr = (qrcode as unknown as (type: number, ec: string) => QrLib)(0, "M");
  qr.addData(text);
  qr.make();
  const n = qr.getModuleCount();
  const size = n * cellSize + margin * 2;
  const cells: string[] = [];
  for (let r = 0; r < n; r++) {
    for (let c = 0; c < n; c++) {
      if (qr.isDark(r, c)) {
        const x = c * cellSize + margin;
        const y = r * cellSize + margin;
        cells.push(`M${x} ${y}h${cellSize}v${cellSize}h-${cellSize}z`);
      }
    }
  }
  return (
    `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}"` +
    ` viewBox="0 0 ${size} ${size}" shape-rendering="crispEdges">` +
    `<rect width="${size}" height="${size}" fill="#fff"/>` +
    `<path fill="#000" d="${cells.join("")}"/></svg>`
  );
}
